// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hL-I","input":"styles_input__ym3g3"};